import getLogger from '@ignitesales/logger-es';
import ignite from '../../../services';

const logger = getLogger({ module: 'notes-action-creators' });

const NotesActions = {
  NOTES_UPDATE_STARTED: 'NOTES_UPDATE_STARTED',
  NOTES_UPDATED: 'NOTES_UPDATED',
  NOTE_ADDED: 'NOTE_ADDED',
  NOTE_UPDATED: 'NOTE_UPDATED',
  NOTE_REMOVED: 'NOTE_REMOVED',
  NOTE_REQUEST_FAILED: 'NOTE_REQUEST_FAILED',
};

const retrieveNotes = () => {
  return async (dispatch) => {
    try {
      dispatch(startProcessing(NotesActions.NOTES_UPDATE_STARTED));
      const notes = await ignite.noteService.retrieveNotes();
      dispatch(setNotes(notes));
    } catch (ex) {
      logger.error('An error occurred while retrieving notes', ex);
      dispatch(notesRequestFailed(ex));
    }
  };
};

const addNote = ({ content }) => {
  return async (dispatch) => {
    try {
      if (content) {
        dispatch(startProcessing(NotesActions.NOTES_UPDATE_STARTED));
        const newNote = await ignite.noteService.addNote(content);
        dispatch(noteAdded(newNote));
      } else {
        logger.warn(
          'No content assigned to this note, will not attempt to add'
        );
      }
    } catch (ex) {
      logger.error('Error occurred while removing a note', ex);
    }
  };
};

const updateNote = ({ id, content }) => {
  return async (dispatch, getState) => {
    try {
      const conversationNotesState = getState().conversationNotes;
      const noteFound = (conversationNotesState.notes || []).find(
        (n) => n.id === id
      );
      if (noteFound) {
        dispatch(startProcessing(NotesActions.NOTES_UPDATE_STARTED));
        const updatedNote = await ignite.noteService.updateNote({
          ...noteFound,
          content,
        });
        dispatch(noteUpdated(updatedNote));
      } else {
        logger.warn('Unable to find note ID during update', id);
      }
    } catch (ex) {
      logger.error('Error occurred while removing a note', ex);
    }
  };
};

const removeNote = (note) => {
  return async (dispatch) => {
    try {
      await ignite.noteService.removeNote(note);
      dispatch(noteRemoved(note));
    } catch (ex) {
      logger.error('Error occurred while removing a note', ex);
    }
  };
};

const startProcessing = (type) => {
  return {
    type,
  };
};

const setNotes = (notes) => {
  return {
    type: NotesActions.NOTES_UPDATED,
    notes,
  };
};

const noteAdded = (note) => {
  return {
    type: NotesActions.NOTE_ADDED,
    note,
  };
};

const noteUpdated = (note) => {
  return {
    type: NotesActions.NOTE_UPDATED,
    note,
  };
};

const noteRemoved = (note) => {
  return {
    type: NotesActions.NOTE_REMOVED,
    note,
  };
};

const notesRequestFailed = (error) => {
  return {
    type: NotesActions.NOTE_REQUEST_FAILED,
    error,
  };
};

export { NotesActions, retrieveNotes, addNote, updateNote, removeNote };
